export default {
  notification: function notification(state) {
    return state.notification;
  }
};